export default __webpack_public_path__ + "locales/zh-CN/Payments.json?hash=b36627258911ecdf3c7383cf4fe96d51";